import { Outlet } from "react-router-dom";
import Navbar from "../components/Navbar.jsx";
import Footer from "../components/Footer.jsx";

export default function Layout() {
  return (
    <div className="App">
      <Navbar />
      <Outlet /> {/* ← each page renders here */}
      <Footer />
    </div>
  );
}
